import styled from "styled-components";
import { BRAND_DARK } from "@streeteasy/design-system/colors";
import TextLink from "@streeteasy/design-system/deprecated/actions/text-link";
import { SecondarySmall } from "@streeteasy/design-system/typography";

export const ProfileInfoContainer = styled(SecondarySmall).attrs({
  as: "p"
})`
  padding: 10px;
  text-align: center;
`;

export const ProfileLink = styled(TextLink)`
  color: ${BRAND_DARK};
  font-size: 16px;
  white-space: nowrap;
`;
